import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { navigate } from "lib/routes/navigate"
import { useParams } from "react-router-dom"
import { Link, Stack } from "@mui/material"
import { assetRegister } from "routes/asset-register/controller/asset-register"
import { Feature } from "lib/@components/feature"
import { FEATURE_FLAG_ASSET_MAPPING } from "routes/asset-register/feature-flag-asset-mapping"
import { HELPTAG_ASSET_REGISTER } from "routes/help/help-tag-constants"
import { HelpTag } from "routes/help/helpTag"
import { NoResultsContainer } from "lib/@components/no-results/no-results"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { AddAssetsImport } from "./add-assets-import"
import { Bound } from "lib/@components/binding/Bound"
import { ONCE } from "lib/graphql/api"
import { emptyObject } from "lib/empty-object"
import { withInitialValue } from "lib/graphql/with-initial-value"

export function AddAssets() {
    const { id } = useParams()
    const register = assetRegister.useResults(id, ONCE, withInitialValue(emptyObject))

    if (register === emptyObject) return <LoadingScreen description={"Add Assets"} />
    if (!register) return <NoResultsContainer message="No Asset Register Found" />

    return (
        <Bound register={register}>
            <PageBreadcrumbContainer
                parentCrumbs={[
                    <Link key="root" sx={{ cursor: "pointer" }} onClick={go}>
                        Asset Registers
                    </Link>,
                    <Link key={register?.name ?? "register"} sx={{ cursor: "pointer" }} onClick={goRegister}>
                        {register?.name ?? ""}
                    </Link>,
                ]}
                title="Add Assets"
                sx={{ height: 1 }}
            >
                <HelpTag tags={[HELPTAG_ASSET_REGISTER]} />
                <Stack sx={{ mt: 2, flex: 1 }}>
                    <Feature feature={FEATURE_FLAG_ASSET_MAPPING}>
                        <AddAssetsImport />
                    </Feature>
                </Stack>
            </PageBreadcrumbContainer>
        </Bound>
    )

    function go() {
        navigate("/app/assets")
    }

    function goRegister() {
        navigate(`/app/assets/${register.id}`)
    }
}
